// TraditionalDemo.jsx
import React from "react";
import DemoMap from "./DemoMap";
import EmailCompose from "./EmailCompose";
import EmailInbox from "./EmailInbox";
import styles from "../styles/TraditionalDemo.module.css";


const TraditionalDemo = ({ step, setStep }) => {
  const goToNextStep = () => {
    setStep((prevStep) => prevStep + 1);
  };

  return (
    <div className={styles.traditionalDemoContainer}>
      {step === 1 && (
          <DemoMap variant="traditional" setStep={setStep} />
      )}

      {step === 2 && (
        <EmailCompose setStep={setStep} />
      )}

      {step === 3 && (
        <EmailInbox setStep={setStep} />
      )}
    </div>
  );
};

export default TraditionalDemo;
